import Rails from '@rails/ujs'

class AccountSwitcher {
  container
  toggle

  constructor(element) {
    this.container = element
    this.toggle = element.querySelector('.account-switcher_toggle')

    // Toggle the dropdown menu.
    this.toggle.addEventListener('click', e => {
      e.preventDefault()

      this.toggleDropdown()
    })

    // Dimiss dropdown when any other element is clicked.
    document.addEventListener('click', e => {
      if (e.target !== this.toggle) {
        this.closeDropdown()
      }
    })

    // Dimiss dropdown when ESC key is pressed.
    document.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
  }

  toggleDropdown() {
    this.container.classList.toggle('account-switcher--open')
  }

  closeDropdown() {
    this.container.classList.remove('account-switcher--open')
  }
}

class MobileAccountSwitcher {
  form
  selector

  constructor(element) {
    this.form = element
    this.selector = element.querySelector('select')

    this.selector.addEventListener('change', e => {
      this.switchAccount(e.target.value)
    })
  }

  switchAccount(url) {
    this.form.action = url
    this.form.submit()
  }
}

document.addEventListener('turbolinks:load', () => {
  Rails.refreshCSRFTokens()

  const accountSwitcher = document.querySelector('.js-account-switcher')
  if (accountSwitcher) new AccountSwitcher(accountSwitcher)

  const mobileAccountSwitcher = document.querySelector(
    '.js-mobile-account-switcher'
  )
  if (mobileAccountSwitcher) new MobileAccountSwitcher(mobileAccountSwitcher)
})
